<template>
  <b-container v-if="customerInfo">
    <div>
      <b-nav class="side-menu-premium" vertical>
        <b-nav-item
          class="play active-menu-button"
          v-for="(step, index) in stepsInfoList"
          :key="step.stepNumber"
          @click="
            contentStep(index);
            updateQueryParams(index);
            step_active = step.stepNumber;
          "
          :class="
            step.stepNumber === step_active && customerInfo.user.paid
              ? 'active'
              : ''
          "
        >
          <span><PlayMaterialIcon /></span>
          <div class="ellipsis" :title="printTitle(index)">
            {{ printTitle(index) }}
          </div>
        </b-nav-item>
        <div class="divider"></div>

        <b-nav-item class="back" href="https://app.dropsmarteo.com"
          ><span><DropsmartDropIcon /></span>Back to Dropsmart</b-nav-item
        >
        <b-nav-item class="logout" href="#" @click="logoff()"
          ><span><LogoutIcon /></span> Logout</b-nav-item
        >
      </b-nav>
      <p class="side-logo text-center">
        <img
          src="../../../assets/images/logo-dropsmart-sidebar.png"
          alt="Logo"
          class=""
        />
      </p>
    </div>
  </b-container>
</template>

<script>
import PlayMaterialIcon from "../../icons/PlayMaterialIcon.vue";
import LogoutIcon from "../../icons/LogoutIcon.vue";
import DropsmartDropIcon from "../../icons/DropsmartDropIcon.vue";

export default {
  name: "MenuLeftPremium",
  props: {
    customerInfo: {
      type: Object,
    },
    stepsInfoList: {
      type: Array,
    },
    stepQuery: {
      default: 1,
    },
  },
  components: {
    PlayMaterialIcon,
    LogoutIcon,
    DropsmartDropIcon,
  },
  data() {
    return {
      step_active: parseInt(this.$route.query.step),
      stepFilter: 1,
    };
  },
  methods: {
    logoff: function() {
      sessionStorage.setItem("customerInfo", null);
      this.$router.push("/login");
    },
    printTitle(index) {
      return (
        this.stepsInfoList[index].stepNumber +
        " - " +
        this.stepsInfoList[index].stepTitle
      );
    },
    contentStep(index) {
      this.$root.$emit(
        "step-number",
        "Step " + this.stepsInfoList[index].stepNumber,
        this.stepsInfoList[index].stepTitle,
        this.stepsInfoList[index].stepUrl,
        this.stepsInfoList[index].stepNumber
      );
    },
    updateQueryParams(index) {
      let queryParamNumber = this.stepsInfoList[index].stepNumber;
      this.$router.push({
        name: "MyPremiumMaterial",
        query: { step: queryParamNumber.toString() },
      });
    },
  },
};
</script>

<style lang="scss">
$color: #000000;

.side-logo {
  padding-top: 250px;
}

.side-menu-premium {
  font-size: 18px;
  margin-top: 60px;
  max-width: 220px;

  .ellipsis {
    width: 285px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .divider {
    background-color: #d7d7d7;
    height: 1px;
    width: 100%;
    max-width: 135px;
    display: block;
    margin: 20px auto;
  }
  .nav-item {
    &.play svg {
      width: 22px;
    }
    &.back svg {
      width: 16px;
    }
    &.logout {
      svg {
        width: 19px;
      }
      span {
        text-align: left;
      }
    }
  }
  .nav-link {
    color: #999999;
    display: flex;
    align-items: center;
    padding: 0;
    line-height: 50px;

    span {
      margin-right: 20px;
      width: 24px;
      text-align: center;
    }
    svg {
      fill: #999999;
      width: 14px;
    }
    &:hover {
      color: #ee4586;
      svg {
        fill: #ee4586;
      }
    }
    &.active {
      color: #ee4586;
      svg {
        fill: #ee4586;
      }
    }
  }
}

@media screen and (max-width: 854px) {
  .side-logo {
    padding-top: 50px;
  }
}
</style>

<style scoped lang="scss">
.active-menu-button {
  &.active {
    svg {
      fill: #ee4586;
    }
    .ellipsis {
      color: #ee4586;
    }
  }
}
</style>
